module.exports = __webpack_public_path__ + "static/media/selecta_mayran.dc0c63bf.png";